// Home page · "Track investor portfolios and activity at scale" illustration
import { CircleUserRound, Tag } from 'lucide-react';
import DemoWrapper from '@/components/DemoWrapper';

export default function HomeInvestorTracking() {
    return (
        <DemoWrapper className="ex-illo bg-slate-50 rounded-md border border-slate-200 ui-shadow p-4 sm:p-6 md:p-8 flex flex-col min-h-[524px] max-[440px]:min-h-[563px] sm:min-h-[474.5px] md:min-h-[490.5px] lg:min-h-[609px] xl:min-h-[490.5px]">
            <div className="flex items-center justify-between mb-5 sm:mb-7">
                <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-blue-500 motion-safe:animate-pulse"></div>
                    <h3 className="text-[15px] leading-5 sm:leading-6 font-semibold text-slate-900">Live Market Signals</h3>
                </div>
            </div>

            <div className="flex-1 flex flex-col gap-3 sm:gap-4">
                {/* Item 1: Expansion */}
                <div className="flex-1 flex flex-col justify-center p-3 sm:p-4 rounded border border-slate-200 bg-white">
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-0 mb-2.5 sm:mb-3">
                        <div className="flex items-center gap-3">
                            <div className="flex items-center text-blue-500 shrink-0">
                                <CircleUserRound size={16} strokeWidth={1.75} />
                            </div>
                            <div className="min-w-0 flex flex-wrap items-baseline gap-x-2">
                                <div className="text-sm sm:text-base font-semibold text-slate-900 truncate ex-fs-14">Sarah Jenkins</div>
                                <div className="text-xs text-slate-500 ex-fs-14">28 Properties, $18.5M Portfolio</div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-100 shrink-0">
                            <Tag size={12} strokeWidth={2} />
                            Rapid Expansion
                        </span>
                        <span className="text-xs text-slate-600 leading-relaxed">Acquired 4 properties in Austin, TX in the last 30 days</span>
                    </div>
                </div>

                {/* Item 2: Disposition */}
                <div className="flex-1 flex flex-col justify-center p-3 sm:p-4 rounded border border-slate-200 bg-white">
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-0 mb-2.5 sm:mb-3">
                        <div className="flex items-center gap-3">
                            <div className="flex items-center text-blue-500 shrink-0">
                                <CircleUserRound size={16} strokeWidth={1.75} />
                            </div>
                            <div className="min-w-0 flex flex-wrap items-baseline gap-x-2">
                                <div className="text-sm sm:text-base font-semibold text-slate-900 truncate ex-fs-14">Marcus Chen</div>
                                <div className="text-xs text-slate-500 ex-fs-14">14 Properties, $8.2M Portfolio</div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-orange-50 text-orange-700 border border-orange-100 shrink-0">
                            <Tag size={12} strokeWidth={2} />
                            Disposition
                        </span>
                        <span className="text-xs text-slate-600 leading-relaxed">Sold 3 multifamily units in Chicago, IL portfolio</span>
                    </div>
                </div>

                {/* Item 3: New Market */}
                <div className="flex-1 flex flex-col justify-center p-3 sm:p-4 rounded border border-slate-200 bg-white">
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-0 mb-2.5 sm:mb-3">
                        <div className="flex items-center gap-3">
                            <div className="flex items-center text-blue-500 shrink-0">
                                <CircleUserRound size={16} strokeWidth={1.75} />
                            </div>
                            <div className="min-w-0 flex flex-wrap items-baseline gap-x-2">
                                <div className="text-sm sm:text-base font-semibold text-slate-900 truncate ex-fs-14">David & Lisa Weber</div>
                                <div className="text-xs text-slate-500 ex-fs-14">8 Properties, $4.1M Portfolio</div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-orange-50 text-orange-700 border border-orange-100 shrink-0">
                            <Tag size={12} strokeWidth={2} />
                            New Market Entry
                        </span>
                        <span className="text-xs text-slate-600 leading-relaxed">First acquisition recorded in Nashville, TN market</span>
                    </div>
                </div>
            </div>
        </DemoWrapper>
    );
}
